import Vue from 'vue'
import { MediaLibraryCollection } from '@spatie/media-library-pro-vue2-collection'

Vue.component('MediaLibraryCollection', MediaLibraryCollection)
